@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import dev.lingvo.site.components.layouts.AppLayout as _dev_lingvo_site_components_layouts_AppLayout
import dev.lingvo.site.components.layouts.EditorLayout as _dev_lingvo_site_components_layouts_EditorLayout
import dev.lingvo.site.pages.AgentsPage as _dev_lingvo_site_pages_AgentsPage
import dev.lingvo.site.pages.AuthCallbackPage as _dev_lingvo_site_pages_AuthCallbackPage
import dev.lingvo.site.pages.CheckoutPage as _dev_lingvo_site_pages_CheckoutPage
import dev.lingvo.site.pages.DesignSystemPage as _dev_lingvo_site_pages_DesignSystemPage
import dev.lingvo.site.pages.DevicePage as _dev_lingvo_site_pages_DevicePage
import dev.lingvo.site.pages.DocsPage as _dev_lingvo_site_pages_DocsPage
import dev.lingvo.site.pages.ForgotPasswordPage as _dev_lingvo_site_pages_ForgotPasswordPage
import dev.lingvo.site.pages.HomePage as _dev_lingvo_site_pages_HomePage
import dev.lingvo.site.pages.InvitePage as _dev_lingvo_site_pages_InvitePage
import dev.lingvo.site.pages.LoginPage as _dev_lingvo_site_pages_LoginPage
import dev.lingvo.site.pages.PricingPage as _dev_lingvo_site_pages_PricingPage
import dev.lingvo.site.pages.PrivacyPage as _dev_lingvo_site_pages_PrivacyPage
import dev.lingvo.site.pages.RefundsPage as _dev_lingvo_site_pages_RefundsPage
import dev.lingvo.site.pages.ResetPasswordPage as _dev_lingvo_site_pages_ResetPasswordPage
import dev.lingvo.site.pages.SignupPage as _dev_lingvo_site_pages_SignupPage
import dev.lingvo.site.pages.StoreAuditPage as _dev_lingvo_site_pages_StoreAuditPage
import dev.lingvo.site.pages.TermsPage as _dev_lingvo_site_pages_TermsPage
import dev.lingvo.site.pages.VerifyEmailPage as _dev_lingvo_site_pages_VerifyEmailPage
import dev.lingvo.site.pages.app.AccountPage as _dev_lingvo_site_pages_app_AccountPage
import dev.lingvo.site.pages.app.ActivityPage as _dev_lingvo_site_pages_app_ActivityPage
import dev.lingvo.site.pages.app.DashboardPage as _dev_lingvo_site_pages_app_DashboardPage
import dev.lingvo.site.pages.app.HelpPage as _dev_lingvo_site_pages_app_HelpPage
import dev.lingvo.site.pages.app.InboxPage as _dev_lingvo_site_pages_app_InboxPage
import dev.lingvo.site.pages.app.InsightsPage as _dev_lingvo_site_pages_app_InsightsPage
import dev.lingvo.site.pages.app.StartPage as _dev_lingvo_site_pages_app_StartPage
import dev.lingvo.site.pages.app.WorkPage as _dev_lingvo_site_pages_app_WorkPage
import dev.lingvo.site.pages.app.WorkspacesPage as _dev_lingvo_site_pages_app_WorkspacesPage
import dev.lingvo.site.pages.app.account.AccountSecurityPage as _dev_lingvo_site_pages_app_account_AccountSecurityPage
import dev.lingvo.site.pages.app.account.CloseAccountPage as _dev_lingvo_site_pages_app_account_CloseAccountPage
import dev.lingvo.site.pages.app.account.NotificationsPage as _dev_lingvo_site_pages_app_account_NotificationsPage
import dev.lingvo.site.pages.app.projects.NewProjectPage as _dev_lingvo_site_pages_app_projects_NewProjectPage
import dev.lingvo.site.pages.app.projects.ProjectsPage as _dev_lingvo_site_pages_app_projects_ProjectsPage
import dev.lingvo.site.pages.app.projects.slug.ImportExportPage as _dev_lingvo_site_pages_app_projects_slug_ImportExportPage
import dev.lingvo.site.pages.app.projects.slug.PretranslatePage as _dev_lingvo_site_pages_app_projects_slug_PretranslatePage
import dev.lingvo.site.pages.app.projects.slug.ProjectDataPage as _dev_lingvo_site_pages_app_projects_slug_ProjectDataPage
import dev.lingvo.site.pages.app.projects.slug.ProjectGlossaryPage as _dev_lingvo_site_pages_app_projects_slug_ProjectGlossaryPage
import dev.lingvo.site.pages.app.projects.slug.ProjectKeysPage as _dev_lingvo_site_pages_app_projects_slug_ProjectKeysPage
import dev.lingvo.site.pages.app.projects.slug.ProjectOverviewPage as _dev_lingvo_site_pages_app_projects_slug_ProjectOverviewPage
import dev.lingvo.site.pages.app.projects.slug.ProjectQaPage as _dev_lingvo_site_pages_app_projects_slug_ProjectQaPage
import dev.lingvo.site.pages.app.projects.slug.ProjectSettingsPage as _dev_lingvo_site_pages_app_projects_slug_ProjectSettingsPage
import dev.lingvo.site.pages.app.projects.slug.ProjectStoresPage as _dev_lingvo_site_pages_app_projects_slug_ProjectStoresPage
import dev.lingvo.site.pages.app.projects.slug.ProposalsPage as _dev_lingvo_site_pages_app_projects_slug_ProposalsPage
import dev.lingvo.site.pages.app.projects.slug.`data`.ProjectJobsPage as _dev_lingvo_site_pages_app_projects_slug_data_ProjectJobsPage
import dev.lingvo.site.pages.app.projects.slug.`data`.jobs.JobReceiptPage as _dev_lingvo_site_pages_app_projects_slug_data_jobs_JobReceiptPage
import dev.lingvo.site.pages.app.projects.slug.keys.ProjectDeletedKeysPage as _dev_lingvo_site_pages_app_projects_slug_keys_ProjectDeletedKeysPage
import dev.lingvo.site.pages.app.projects.slug.review.ReviewLanePage as _dev_lingvo_site_pages_app_projects_slug_review_ReviewLanePage
import dev.lingvo.site.pages.app.projects.slug.screenshots.ScreenshotDesignPage as _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotDesignPage
import dev.lingvo.site.pages.app.projects.slug.screenshots.ScreenshotReviewPage as _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotReviewPage
import dev.lingvo.site.pages.app.projects.slug.screenshots.ScreenshotTemplatesPage as _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotTemplatesPage
import dev.lingvo.site.pages.app.projects.slug.screenshots.ScreenshotsAgentsPage as _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotsAgentsPage
import dev.lingvo.site.pages.app.projects.slug.screenshots.ScreenshotsPlanPage as _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotsPlanPage
import dev.lingvo.site.pages.app.projects.slug.screenshots.ScreenshotsUpdatesPage as _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotsUpdatesPage
import dev.lingvo.site.pages.app.projects.slug.settings.ProjectProvidersPage as _dev_lingvo_site_pages_app_projects_slug_settings_ProjectProvidersPage
import dev.lingvo.site.pages.app.projects.slug.settings.ProjectQaSettingsPage as _dev_lingvo_site_pages_app_projects_slug_settings_ProjectQaSettingsPage
import dev.lingvo.site.pages.app.projects.slug.strings.StringPermalinkPage as _dev_lingvo_site_pages_app_projects_slug_strings_StringPermalinkPage
import dev.lingvo.site.pages.app.projects.slug.translate.TranslationEditorPage as _dev_lingvo_site_pages_app_projects_slug_translate_TranslationEditorPage
import dev.lingvo.site.pages.app.reports.SpendReportPage as _dev_lingvo_site_pages_app_reports_SpendReportPage
import dev.lingvo.site.pages.app.settings.AgentsPage as _dev_lingvo_site_pages_app_settings_AgentsPage
import dev.lingvo.site.pages.app.settings.AuditPage as _dev_lingvo_site_pages_app_settings_AuditPage
import dev.lingvo.site.pages.app.settings.SettingsIndexPage as _dev_lingvo_site_pages_app_settings_SettingsIndexPage
import dev.lingvo.site.pages.app.settings.TokensPage as _dev_lingvo_site_pages_app_settings_TokensPage
import dev.lingvo.site.pages.app.settings.UsagePage as _dev_lingvo_site_pages_app_settings_UsagePage
import dev.lingvo.site.pages.app.settings.WebhooksPage as _dev_lingvo_site_pages_app_settings_WebhooksPage
import dev.lingvo.site.pages.app.settings.WorkspaceBillingPage as _dev_lingvo_site_pages_app_settings_WorkspaceBillingPage
import dev.lingvo.site.pages.app.settings.WorkspaceGeneralPage as _dev_lingvo_site_pages_app_settings_WorkspaceGeneralPage
import dev.lingvo.site.pages.app.settings.WorkspaceMembersPage as _dev_lingvo_site_pages_app_settings_WorkspaceMembersPage
import dev.lingvo.site.pages.app.settings.WorkspaceProvidersPage as _dev_lingvo_site_pages_app_settings_WorkspaceProvidersPage
import dev.lingvo.site.pages.app.settings.agents.AgentDetailPage as _dev_lingvo_site_pages_app_settings_agents_AgentDetailPage
import dev.lingvo.site.pages.app.settings.agents.NewAgentPage as _dev_lingvo_site_pages_app_settings_agents_NewAgentPage
import dev.lingvo.site.pages.app.settings.agents.SpendApprovalsPage as _dev_lingvo_site_pages_app_settings_agents_SpendApprovalsPage
import dev.lingvo.site.pages.app.settings.agents.agentId.AgentLogPage as _dev_lingvo_site_pages_app_settings_agents_agentId_AgentLogPage
import dev.lingvo.site.pages.app.settings.agents.setup.AgentSetupPage as _dev_lingvo_site_pages_app_settings_agents_setup_AgentSetupPage
import dev.lingvo.site.pages.app.settings.billing.BillingConfirmingPage as _dev_lingvo_site_pages_app_settings_billing_BillingConfirmingPage
import dev.lingvo.site.pages.app.settings.billing.CancelSubscriptionPage as _dev_lingvo_site_pages_app_settings_billing_CancelSubscriptionPage
import dev.lingvo.site.pages.app.settings.billing.FixPaymentPage as _dev_lingvo_site_pages_app_settings_billing_FixPaymentPage
import dev.lingvo.site.pages.app.settings.billing.InvoicesPage as _dev_lingvo_site_pages_app_settings_billing_InvoicesPage
import dev.lingvo.site.pages.app.settings.billing.PlansPage as _dev_lingvo_site_pages_app_settings_billing_PlansPage
import dev.lingvo.site.pages.app.settings.billing.SeatsPage as _dev_lingvo_site_pages_app_settings_billing_SeatsPage
import dev.lingvo.site.pages.app.settings.providers.WorkspaceProviderPage as _dev_lingvo_site_pages_app_settings_providers_WorkspaceProviderPage
import dev.lingvo.site.pages.app.settings.tokens.NewTokenPage as _dev_lingvo_site_pages_app_settings_tokens_NewTokenPage
import dev.lingvo.site.pages.app.settings.tokens.TokenDetailPage as _dev_lingvo_site_pages_app_settings_tokens_TokenDetailPage
import dev.lingvo.site.pages.app.settings.usage.BudgetsPage as _dev_lingvo_site_pages_app_settings_usage_BudgetsPage
import dev.lingvo.site.pages.app.settings.usage.UsageEventsPage as _dev_lingvo_site_pages_app_settings_usage_UsageEventsPage
import dev.lingvo.site.pages.app.settings.webhooks.WebhookDetailPage as _dev_lingvo_site_pages_app_settings_webhooks_WebhookDetailPage
import dev.lingvo.site.pages.app.start.GitHubImportPage as _dev_lingvo_site_pages_app_start_GitHubImportPage
import dev.lingvo.site.pages.docs.CliCommandReferencePage as _dev_lingvo_site_pages_docs_CliCommandReferencePage
import dev.lingvo.site.pages.docs.CliDocsPage as _dev_lingvo_site_pages_docs_CliDocsPage
import dev.lingvo.site.pages.docs.FormatsPage as _dev_lingvo_site_pages_docs_FormatsPage
import dev.lingvo.site.pages.docs.McpDocsPage as _dev_lingvo_site_pages_docs_McpDocsPage
import dev.lingvo.site.pages.docs.ScreenshotCiDocsPage as _dev_lingvo_site_pages_docs_ScreenshotCiDocsPage
import dev.lingvo.site.pages.docs.ScreenshotsDocsPage as _dev_lingvo_site_pages_docs_ScreenshotsDocsPage
import dev.lingvo.site.pages.docs.StoresDocsPage as _dev_lingvo_site_pages_docs_StoresDocsPage
import dev.lingvo.site.pages.review.PublicScreenshotReviewPage as _dev_lingvo_site_pages_review_PublicScreenshotReviewPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Lingvo"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx, pageMethod -> 
            _dev_lingvo_site_components_layouts_AppLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.registerLayout(
            "dev.lingvo.site.components.layouts.EditorLayout",
        ) { pageCtx, pageMethod -> 
            _dev_lingvo_site_components_layouts_EditorLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_HomePage()
        }
        ctx.router.register(
            "/agents",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_AgentsPage()
        }
        ctx.router.register(
            "/app",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_DashboardPage()
        }
        ctx.router.register(
            "/app/account",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_AccountPage()
        }
        ctx.router.register(
            "/app/account/close",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_account_CloseAccountPage()
        }
        ctx.router.register(
            "/app/account/notifications",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_account_NotificationsPage()
        }
        ctx.router.register(
            "/app/account/security",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_account_AccountSecurityPage()
        }
        ctx.router.register(
            "/app/activity",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_ActivityPage()
        }
        ctx.router.register(
            "/app/help",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_HelpPage()
        }
        ctx.router.register(
            "/app/inbox",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_InboxPage()
        }
        ctx.router.register(
            "/app/insights",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_InsightsPage()
        }
        ctx.router.register(
            "/app/projects",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_ProjectsPage()
        }
        ctx.router.register(
            "/app/projects/new",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_NewProjectPage()
        }
        ctx.router.register(
            "/app/projects/{slug}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ProjectOverviewPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/data",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ProjectDataPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/data/jobs",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_data_ProjectJobsPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/data/jobs/{jobId}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_data_jobs_JobReceiptPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/glossary",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ProjectGlossaryPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/import-export",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ImportExportPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/keys",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ProjectKeysPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/keys/deleted",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_keys_ProjectDeletedKeysPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/pretranslate",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_PretranslatePage()
        }
        ctx.router.register(
            "/app/projects/{slug}/proposals",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ProposalsPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/qa",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ProjectQaPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/review/{locale}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_review_ReviewLanePage()
        }
        ctx.router.register(
            "/app/projects/{slug}/screenshots",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotsPlanPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/screenshots/agents",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotsAgentsPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/screenshots/design",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotDesignPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/screenshots/review",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotReviewPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/screenshots/templates",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotTemplatesPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/screenshots/updates",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_screenshots_ScreenshotsUpdatesPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/settings",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ProjectSettingsPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/settings/providers",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_settings_ProjectProvidersPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/settings/qa",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_settings_ProjectQaSettingsPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/stores",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_ProjectStoresPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/strings/{keyId}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_strings_StringPermalinkPage()
        }
        ctx.router.register(
            "/app/projects/{slug}/translate/{locale}",
            layoutId = "dev.lingvo.site.components.layouts.EditorLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_projects_slug_translate_TranslationEditorPage()
        }
        ctx.router.register(
            "/app/reports/spend",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_reports_SpendReportPage()
        }
        ctx.router.register(
            "/app/settings",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_SettingsIndexPage()
        }
        ctx.router.register(
            "/app/settings/agents",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_AgentsPage()
        }
        ctx.router.register(
            "/app/settings/agents/approvals",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_agents_SpendApprovalsPage()
        }
        ctx.router.register(
            "/app/settings/agents/new",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_agents_NewAgentPage()
        }
        ctx.router.register(
            "/app/settings/agents/setup/{client}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_agents_setup_AgentSetupPage()
        }
        ctx.router.register(
            "/app/settings/agents/{agentId}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_agents_AgentDetailPage()
        }
        ctx.router.register(
            "/app/settings/agents/{agentId}/log",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_agents_agentId_AgentLogPage()
        }
        ctx.router.register(
            "/app/settings/audit",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_AuditPage()
        }
        ctx.router.register(
            "/app/settings/billing",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_WorkspaceBillingPage()
        }
        ctx.router.register(
            "/app/settings/billing/cancel",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_billing_CancelSubscriptionPage()
        }
        ctx.router.register(
            "/app/settings/billing/confirming",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_billing_BillingConfirmingPage()
        }
        ctx.router.register(
            "/app/settings/billing/fix-payment",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_billing_FixPaymentPage()
        }
        ctx.router.register(
            "/app/settings/billing/invoices",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_billing_InvoicesPage()
        }
        ctx.router.register(
            "/app/settings/billing/plans",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_billing_PlansPage()
        }
        ctx.router.register(
            "/app/settings/billing/seats",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_billing_SeatsPage()
        }
        ctx.router.register(
            "/app/settings/general",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_WorkspaceGeneralPage()
        }
        ctx.router.register(
            "/app/settings/members",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_WorkspaceMembersPage()
        }
        ctx.router.register(
            "/app/settings/providers",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_WorkspaceProvidersPage()
        }
        ctx.router.register(
            "/app/settings/providers/{providerId}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_providers_WorkspaceProviderPage()
        }
        ctx.router.register(
            "/app/settings/tokens",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_TokensPage()
        }
        ctx.router.register(
            "/app/settings/tokens/new",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_tokens_NewTokenPage()
        }
        ctx.router.register(
            "/app/settings/tokens/{tokenId}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_tokens_TokenDetailPage()
        }
        ctx.router.register(
            "/app/settings/usage",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_UsagePage()
        }
        ctx.router.register(
            "/app/settings/usage/budgets",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_usage_BudgetsPage()
        }
        ctx.router.register(
            "/app/settings/usage/events",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_usage_UsageEventsPage()
        }
        ctx.router.register(
            "/app/settings/webhooks",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_WebhooksPage()
        }
        ctx.router.register(
            "/app/settings/webhooks/{webhookId}",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_settings_webhooks_WebhookDetailPage()
        }
        ctx.router.register(
            "/app/start",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_StartPage()
        }
        ctx.router.register(
            "/app/start/github",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_start_GitHubImportPage()
        }
        ctx.router.register(
            "/app/work",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_WorkPage()
        }
        ctx.router.register(
            "/app/workspaces",
            layoutId = "dev.lingvo.site.components.layouts.AppLayout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_app_WorkspacesPage()
        }
        ctx.router.register(
            "/auth/callback",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_AuthCallbackPage()
        }
        ctx.router.register(
            "/checkout",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_CheckoutPage()
        }
        ctx.router.register(
            "/device",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_DevicePage()
        }
        ctx.router.register(
            "/docs",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_DocsPage()
        }
        ctx.router.register(
            "/docs/cli",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_docs_CliDocsPage()
        }
        ctx.router.register(
            "/docs/cli/commands",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_docs_CliCommandReferencePage()
        }
        ctx.router.register(
            "/docs/formats",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_docs_FormatsPage()
        }
        ctx.router.register(
            "/docs/mcp",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_docs_McpDocsPage()
        }
        ctx.router.register(
            "/docs/screenshot-ci",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_docs_ScreenshotCiDocsPage()
        }
        ctx.router.register(
            "/docs/screenshots",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_docs_ScreenshotsDocsPage()
        }
        ctx.router.register(
            "/docs/stores",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_docs_StoresDocsPage()
        }
        ctx.router.register(
            "/ds",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_DesignSystemPage()
        }
        ctx.router.register(
            "/forgot-password",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_ForgotPasswordPage()
        }
        ctx.router.register(
            "/invite",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_InvitePage()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_LoginPage()
        }
        ctx.router.register(
            "/pricing",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_PricingPage()
        }
        ctx.router.register(
            "/privacy",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_PrivacyPage()
        }
        ctx.router.register(
            "/refunds",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_RefundsPage()
        }
        ctx.router.register(
            "/reset-password",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_ResetPasswordPage()
        }
        ctx.router.register(
            "/review/screenshots",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_review_PublicScreenshotReviewPage()
        }
        ctx.router.register(
            "/signup",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_SignupPage()
        }
        ctx.router.register(
            "/store-audit",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_StoreAuditPage()
        }
        ctx.router.register(
            "/terms",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_TermsPage()
        }
        ctx.router.register(
            "/verify-email",
        ) { pageCtx -> 
            _dev_lingvo_site_pages_VerifyEmailPage()
        }

        dev.lingvo.site.components.studio.compose.initComposeRunLifetime(ctx)
        dev.lingvo.site.initPublicMetadata(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("ds-page", dev.lingvo.site.ds.DsPageStyle)
        ctx.theme.registerStyle("ds-hero", dev.lingvo.site.ds.DsHeroStyle)
        ctx.theme.registerStyle("ds-hero-header", dev.lingvo.site.ds.DsHeroHeaderStyle)
        ctx.theme.registerStyle("ds-gallery", dev.lingvo.site.ds.DsGalleryStyle)
        ctx.theme.registerStyle("ds-section", dev.lingvo.site.ds.DsSectionStyle)
        ctx.theme.registerStyle("ds-specimen-grid", dev.lingvo.site.ds.DsSpecimenGridStyle)
        ctx.theme.registerStyle("ds-ground", dev.lingvo.site.ds.DsGroundStyle)
        ctx.theme.registerStyle("ds-icon-sheet", dev.lingvo.site.ds.DsIconSheetStyle)
        ctx.theme.registerStyle("ds-icon-cell", dev.lingvo.site.ds.DsIconCellStyle)
        ctx.theme.registerStyle("ds-identity-grid", dev.lingvo.site.ds.DsIdentityGridStyle)
        ctx.theme.registerStyle("ds-glyph-grid", dev.lingvo.site.ds.DsGlyphGridStyle)
        ctx.theme.registerStyle("locale-flag", dev.lingvo.site.components.LocaleFlagStyle)
        ctx.theme.registerStyle("progress-cell", dev.lingvo.site.components.ProgressCellStyle)
        ctx.theme.registerStyle("plain-link", dev.lingvo.site.components.PlainLinkStyle)
        ctx.theme.registerStyle("linked-counter", dev.lingvo.site.components.LinkedCounterStyle)
        ctx.theme.registerStyle("app-shell-root", dev.lingvo.site.components.AppShellRootStyle)
        ctx.theme.registerStyle("app-sidebar", dev.lingvo.site.components.AppSidebarStyle)
        ctx.theme.registerStyle("app-main", dev.lingvo.site.components.AppMainStyle)
        ctx.theme.registerStyle("app-top-bar", dev.lingvo.site.components.AppTopBarStyle)
        ctx.theme.registerStyle("mobile-navigation-trigger", dev.lingvo.site.components.MobileNavigationTriggerStyle)
        ctx.theme.registerStyle("mobile-navigation-scrim", dev.lingvo.site.components.MobileNavigationScrimStyle)
        ctx.theme.registerStyle("mobile-navigation-surface", dev.lingvo.site.components.MobileNavigationSurfaceStyle)
        ctx.theme.registerStyle("app-content", dev.lingvo.site.components.AppContentStyle)
        ctx.theme.registerStyle("shell-notice-stack", dev.lingvo.site.components.ShellNoticeStackStyle)
        ctx.theme.registerStyle("app-logo", dev.lingvo.site.components.AppLogoStyle)
        ctx.theme.registerStyle("app-logo-mark", dev.lingvo.site.components.AppLogoMarkStyle)
        ctx.theme.registerStyle("app-nav-group-label", dev.lingvo.site.components.AppNavGroupLabelStyle)
        ctx.theme.registerStyle("app-nav-divider", dev.lingvo.site.components.AppNavDividerStyle)
        ctx.theme.registerStyle("app-nav-item", dev.lingvo.site.components.AppNavItemStyle)
        ctx.theme.registerStyle("app-trail", dev.lingvo.site.components.AppTrailStyle)
        ctx.theme.registerStyle("app-trail-crumb", dev.lingvo.site.components.AppTrailCrumbStyle)
        ctx.theme.registerStyle("app-trail-trigger", dev.lingvo.site.components.AppTrailTriggerStyle)
        ctx.theme.registerStyle("app-trail-chevron", dev.lingvo.site.components.AppTrailChevronStyle)
        ctx.theme.registerStyle("app-trail-separator", dev.lingvo.site.components.AppTrailSeparatorStyle)
        ctx.theme.registerStyle("app-trail-current", dev.lingvo.site.components.AppTrailCurrentStyle)
        ctx.theme.registerStyle("app-trail-trigger-label", dev.lingvo.site.components.AppTrailTriggerLabelStyle)
        ctx.theme.registerStyle("app-trail-popover", dev.lingvo.site.components.AppTrailPopoverStyle)
        ctx.theme.registerStyle("app-trail-row", dev.lingvo.site.components.AppTrailRowStyle)
        ctx.theme.registerStyle("module-card", dev.lingvo.site.components.github.ModuleCardStyle)
        ctx.theme.registerStyle("locale-row", dev.lingvo.site.components.github.LocaleRowStyle)
        ctx.theme.registerStyle("editor-layout-root", dev.lingvo.site.components.layouts.EditorLayoutRootStyle)
        ctx.theme.registerStyle("editor-shell-loading-workspace", dev.lingvo.site.components.layouts.EditorShellLoadingWorkspaceStyle)
        ctx.theme.registerStyle("editor-shell-loading-frame", dev.lingvo.site.components.layouts.EditorShellLoadingFrameStyle)
        ctx.theme.registerStyle("multiplication-grid", dev.lingvo.site.components.marketing.MultiplicationGridStyle)
        ctx.theme.registerStyle("multiplication-panel", dev.lingvo.site.components.marketing.MultiplicationPanelStyle)
        ctx.theme.registerStyle("billed-panel", dev.lingvo.site.components.marketing.BilledPanelStyle)
        ctx.theme.registerStyle("seat-panel", dev.lingvo.site.components.marketing.SeatPanelStyle)
        ctx.theme.registerStyle("billed-cell", dev.lingvo.site.components.marketing.BilledCellStyle)
        ctx.theme.registerStyle("seat-cell", dev.lingvo.site.components.marketing.SeatCellStyle)
        ctx.theme.registerStyle("marketing-section", dev.lingvo.site.components.marketing.MarketingSectionStyle)
        ctx.theme.registerStyle("compact-section", dev.lingvo.site.components.marketing.CompactSectionStyle)
        ctx.theme.registerStyle("formats-list", dev.lingvo.site.components.marketing.FormatsListStyle)
        ctx.theme.registerStyle("marketing-page-column", dev.lingvo.site.components.marketing.MarketingPageColumnStyle)
        ctx.theme.registerStyle("marketing-section-inner", dev.lingvo.site.components.marketing.MarketingSectionInnerStyle)
        ctx.theme.registerStyle("margin-rail", dev.lingvo.site.components.marketing.MarginRailStyle)
        ctx.theme.registerStyle("margin-note", dev.lingvo.site.components.marketing.MarginNoteStyle)
        ctx.theme.registerStyle("auth-page", dev.lingvo.site.components.marketing.AuthPageStyle)
        ctx.theme.registerStyle("auth-form-side", dev.lingvo.site.components.marketing.AuthFormSideStyle)
        ctx.theme.registerStyle("auth-form-content", dev.lingvo.site.components.marketing.AuthFormContentStyle)
        ctx.theme.registerStyle("auth-title", dev.lingvo.site.components.marketing.AuthTitleStyle)
        ctx.theme.registerStyle("auth-subtitle", dev.lingvo.site.components.marketing.AuthSubtitleStyle)
        ctx.theme.registerStyle("auth-artwork", dev.lingvo.site.components.marketing.AuthArtworkStyle)
        ctx.theme.registerStyle("auth-artwork-inner", dev.lingvo.site.components.marketing.AuthArtworkInnerStyle)
        ctx.theme.registerStyle("auth-artwork-label", dev.lingvo.site.components.marketing.AuthArtworkLabelStyle)
        ctx.theme.registerStyle("auth-greeting-list", dev.lingvo.site.components.marketing.AuthGreetingListStyle)
        ctx.theme.registerStyle("auth-greeting-row", dev.lingvo.site.components.marketing.AuthGreetingRowStyle)
        ctx.theme.registerStyle("auth-greeting-word", dev.lingvo.site.components.marketing.AuthGreetingWordStyle)
        ctx.theme.registerStyle("auth-greeting-accent", dev.lingvo.site.components.marketing.AuthGreetingAccentStyle)
        ctx.theme.registerStyle("auth-greeting-code", dev.lingvo.site.components.marketing.AuthGreetingCodeStyle)
        ctx.theme.registerStyle("auth-artwork-note", dev.lingvo.site.components.marketing.AuthArtworkNoteStyle)
        ctx.theme.registerStyle("auth-field-frame", dev.lingvo.site.components.marketing.AuthFieldFrameStyle)
        ctx.theme.registerStyle("auth-field-help", dev.lingvo.site.components.marketing.AuthFieldHelpStyle)
        ctx.theme.registerStyle("auth-field-error", dev.lingvo.site.components.marketing.AuthFieldErrorStyle)
        ctx.theme.registerStyle("auth-field-error-icon", dev.lingvo.site.components.marketing.AuthFieldErrorIconStyle)
        ctx.theme.registerStyle("auth-handoff-mark", dev.lingvo.site.components.marketing.AuthHandoffMarkStyle)
        ctx.theme.registerStyle("auth-handoff", dev.lingvo.site.components.marketing.AuthHandoffStyle)
        ctx.theme.registerStyle("auth-handoff-inner", dev.lingvo.site.components.marketing.AuthHandoffInnerStyle)
        ctx.theme.registerStyle("auth-handoff-message", dev.lingvo.site.components.marketing.AuthHandoffMessageStyle)
        ctx.theme.registerStyle("multiplication-band-head", dev.lingvo.site.components.marketing.MultiplicationBandHeadStyle)
        ctx.theme.registerStyle("multiplication-band-head-lead", dev.lingvo.site.components.marketing.MultiplicationBandHeadLeadStyle)
        ctx.theme.registerStyle("multiplication-band-note", dev.lingvo.site.components.marketing.MultiplicationBandNoteStyle)
        ctx.theme.registerStyle("multiplication-band-grid", dev.lingvo.site.components.marketing.MultiplicationBandGridStyle)
        ctx.theme.registerStyle("multiplication-band-cell", dev.lingvo.site.components.marketing.MultiplicationBandCellStyle)
        ctx.theme.registerStyle("multiplication-band-code", dev.lingvo.site.components.marketing.MultiplicationBandCodeStyle)
        ctx.theme.registerStyle("multiplication-band-source-code", dev.lingvo.site.components.marketing.MultiplicationBandSourceCodeStyle)
        ctx.theme.registerStyle("multiplication-band-string", dev.lingvo.site.components.marketing.MultiplicationBandStringStyle)
        ctx.theme.registerStyle("multiplication-band-source-string", dev.lingvo.site.components.marketing.MultiplicationBandSourceStringStyle)
        ctx.theme.registerStyle("multiplication-band-tally", dev.lingvo.site.components.marketing.MultiplicationBandTallyStyle)
        ctx.theme.registerStyle("multiplication-band-counts", dev.lingvo.site.components.marketing.MultiplicationBandCountsStyle)
        ctx.theme.registerStyle("multiplication-band-count", dev.lingvo.site.components.marketing.MultiplicationBandCountStyle)
        ctx.theme.registerStyle("multiplication-band-count-value", dev.lingvo.site.components.marketing.MultiplicationBandCountValueStyle)
        ctx.theme.registerStyle("multiplication-band-accent-figure", dev.lingvo.site.components.marketing.MultiplicationBandAccentFigureStyle)
        ctx.theme.registerStyle("multiplication-band-count-label", dev.lingvo.site.components.marketing.MultiplicationBandCountLabelStyle)
        ctx.theme.registerStyle("multiplication-band-still", dev.lingvo.site.components.marketing.MultiplicationBandStillStyle)
        ctx.theme.registerStyle("multiplication-band-still-label", dev.lingvo.site.components.marketing.MultiplicationBandStillLabelStyle)
        ctx.theme.registerStyle("multiplication-band-price", dev.lingvo.site.components.marketing.MultiplicationBandPriceStyle)
        ctx.theme.registerStyle("docs-section", dev.lingvo.site.components.marketing.DocsSectionStyle)
        ctx.theme.registerStyle("docs-inline-code", dev.lingvo.site.components.marketing.DocsInlineCodeStyle)
        ctx.theme.registerStyle("docs-inline-link", dev.lingvo.site.components.marketing.DocsInlineLinkStyle)
        ctx.theme.registerStyle("docs-list", dev.lingvo.site.components.marketing.DocsListStyle)
        ctx.theme.registerStyle("locale-strip", dev.lingvo.site.components.marketing.LocaleStripStyle)
        ctx.theme.registerStyle("locale-code", dev.lingvo.site.components.marketing.LocaleCodeStyle)
        ctx.theme.registerStyle("locale-pivot", dev.lingvo.site.components.marketing.LocalePivotStyle)
        ctx.theme.registerStyle("agent-setup-shell", dev.lingvo.site.components.marketing.AgentSetupShellStyle)
        ctx.theme.registerStyle("agent-client-picker", dev.lingvo.site.components.marketing.AgentClientPickerStyle)
        ctx.theme.registerStyle("agent-client-choice", dev.lingvo.site.components.marketing.AgentClientChoiceStyle)
        ctx.theme.registerStyle("agent-setup-transport", dev.lingvo.site.components.marketing.AgentSetupTransportStyle)
        ctx.theme.registerStyle("agent-transport-choice", dev.lingvo.site.components.marketing.AgentTransportChoiceStyle)
        ctx.theme.registerStyle("agent-setup-note", dev.lingvo.site.components.marketing.AgentSetupNoteStyle)
        ctx.theme.registerStyle("agent-setup-steps", dev.lingvo.site.components.marketing.AgentSetupStepsStyle)
        ctx.theme.registerStyle("agent-setup-step", dev.lingvo.site.components.marketing.AgentSetupStepStyle)
        ctx.theme.registerStyle("agent-setup-number", dev.lingvo.site.components.marketing.AgentSetupNumberStyle)
        ctx.theme.registerStyle("agent-setup-step-title", dev.lingvo.site.components.marketing.AgentSetupStepTitleStyle)
        ctx.theme.registerStyle("loop-pipeline", dev.lingvo.site.components.marketing.LoopPipelineStyle)
        ctx.theme.registerStyle("loop-stage", dev.lingvo.site.components.marketing.LoopStageStyle)
        ctx.theme.registerStyle("loop-card", dev.lingvo.site.components.marketing.LoopCardStyle)
        ctx.theme.registerStyle("loop-chip", dev.lingvo.site.components.marketing.LoopChipStyle)
        ctx.theme.registerStyle("hero-pitch", dev.lingvo.site.components.marketing.HeroPitchStyle)
        ctx.theme.registerStyle("hero-lead", dev.lingvo.site.components.marketing.HeroLeadStyle)
        ctx.theme.registerStyle("hero-headline", dev.lingvo.site.components.marketing.HeroHeadlineStyle)
        ctx.theme.registerStyle("hero-lede", dev.lingvo.site.components.marketing.HeroLedeStyle)
        ctx.theme.registerStyle("hero-actions", dev.lingvo.site.components.marketing.HeroActionsStyle)
        ctx.theme.registerStyle("hero-docs-link", dev.lingvo.site.components.marketing.HeroDocsLinkStyle)
        ctx.theme.registerStyle("hero-docs-arrow", dev.lingvo.site.components.marketing.HeroDocsArrowStyle)
        ctx.theme.registerStyle("hero-product-figure", dev.lingvo.site.components.marketing.HeroProductFigureStyle)
        ctx.theme.registerStyle("hero-product-image", dev.lingvo.site.components.marketing.HeroProductImageStyle)
        ctx.theme.registerStyle("hero-product-caption", dev.lingvo.site.components.marketing.HeroProductCaptionStyle)
        ctx.theme.registerStyle("docs-layout", dev.lingvo.site.components.marketing.DocsLayoutStyle)
        ctx.theme.registerStyle("docs-rail", dev.lingvo.site.components.marketing.DocsRailStyle)
        ctx.theme.registerStyle("docs-contents", dev.lingvo.site.components.marketing.DocsContentsStyle)
        ctx.theme.registerStyle("docs-contents-summary", dev.lingvo.site.components.marketing.DocsContentsSummaryStyle)
        ctx.theme.registerStyle("docs-contents-list", dev.lingvo.site.components.marketing.DocsContentsListStyle)
        ctx.theme.registerStyle("docs-rail-link", dev.lingvo.site.components.marketing.DocsRailLinkStyle)
        ctx.theme.registerStyle("docs-welcome", dev.lingvo.site.components.marketing.DocsWelcomeStyle)
        ctx.theme.registerStyle("docs-welcome-start", dev.lingvo.site.components.marketing.DocsWelcomeStartStyle)
        ctx.theme.registerStyle("docs-welcome-link", dev.lingvo.site.components.marketing.DocsWelcomeLinkStyle)
        ctx.theme.registerStyle("band", dev.lingvo.site.components.marketing.BandStyle)
        ctx.theme.registerStyle("band-inner", dev.lingvo.site.components.marketing.BandInnerStyle)
        ctx.theme.registerStyle("band-paper", dev.lingvo.site.components.marketing.BandPaperStyle)
        ctx.theme.registerStyle("band-paper-sunken", dev.lingvo.site.components.marketing.BandPaperSunkenStyle)
        ctx.theme.registerStyle("band-ink", dev.lingvo.site.components.marketing.BandInkStyle)
        ctx.theme.registerStyle("band-label", dev.lingvo.site.components.marketing.BandLabelStyle)
        ctx.theme.registerStyle("band-label-ink", dev.lingvo.site.components.marketing.BandLabelInkStyle)
        ctx.theme.registerStyle("band-heading", dev.lingvo.site.components.marketing.BandHeadingStyle)
        ctx.theme.registerStyle("band-heading-ink", dev.lingvo.site.components.marketing.BandHeadingInkStyle)
        ctx.theme.registerStyle("script-wall", dev.lingvo.site.components.marketing.ScriptWallStyle)
        ctx.theme.registerStyle("script-wall-line", dev.lingvo.site.components.marketing.ScriptWallLineStyle)
        ctx.theme.registerStyle("script-wall-word", dev.lingvo.site.components.marketing.ScriptWallWordStyle)
        ctx.theme.registerStyle("wall-accent", dev.lingvo.site.components.marketing.WallAccentStyle)
        ctx.theme.registerStyle("agent-value-table", dev.lingvo.site.components.marketing.AgentValueTableStyle)
        ctx.theme.registerStyle("agent-value-head", dev.lingvo.site.components.marketing.AgentValueHeadStyle)
        ctx.theme.registerStyle("agent-value-body", dev.lingvo.site.components.marketing.AgentValueBodyStyle)
        ctx.theme.registerStyle("agent-value-row", dev.lingvo.site.components.marketing.AgentValueRowStyle)
        ctx.theme.registerStyle("agent-value-cell", dev.lingvo.site.components.marketing.AgentValueCellStyle)
        ctx.theme.registerStyle("agent-value-cell-label", dev.lingvo.site.components.marketing.AgentValueCellLabelStyle)
        ctx.theme.registerStyle("limits-head", dev.lingvo.site.components.marketing.LimitsHeadStyle)
        ctx.theme.registerStyle("limits-columns", dev.lingvo.site.components.marketing.LimitsColumnsStyle)
        ctx.theme.registerStyle("limits-column", dev.lingvo.site.components.marketing.LimitsColumnStyle)
        ctx.theme.registerStyle("limits-switch-column", dev.lingvo.site.components.marketing.LimitsSwitchColumnStyle)
        ctx.theme.registerStyle("limits-stay-column", dev.lingvo.site.components.marketing.LimitsStayColumnStyle)
        ctx.theme.registerStyle("limits-column-head", dev.lingvo.site.components.marketing.LimitsColumnHeadStyle)
        ctx.theme.registerStyle("limits-column-title", dev.lingvo.site.components.marketing.LimitsColumnTitleStyle)
        ctx.theme.registerStyle("limits-glyph", dev.lingvo.site.components.marketing.LimitsGlyphStyle)
        ctx.theme.registerStyle("limits-rows", dev.lingvo.site.components.marketing.LimitsRowsStyle)
        ctx.theme.registerStyle("limits-row", dev.lingvo.site.components.marketing.LimitsRowStyle)
        ctx.theme.registerStyle("limits-row-text", dev.lingvo.site.components.marketing.LimitsRowTextStyle)
        ctx.theme.registerStyle("limits-row-lead", dev.lingvo.site.components.marketing.LimitsRowLeadStyle)
        ctx.theme.registerStyle("limits-row-note", dev.lingvo.site.components.marketing.LimitsRowNoteStyle)
        ctx.theme.registerStyle("public-header", dev.lingvo.site.components.marketing.PublicHeaderStyle)
        ctx.theme.registerStyle("public-header-inner", dev.lingvo.site.components.marketing.PublicHeaderInnerStyle)
        ctx.theme.registerStyle("public-mobile-menu", dev.lingvo.site.components.marketing.PublicMobileMenuStyle)
        ctx.theme.registerStyle("public-mobile-menu-trigger", dev.lingvo.site.components.marketing.PublicMobileMenuTriggerStyle)
        ctx.theme.registerStyle("public-mobile-menu-panel", dev.lingvo.site.components.marketing.PublicMobileMenuPanelStyle)
        ctx.theme.registerStyle("public-mobile-menu-current-link", dev.lingvo.site.components.marketing.PublicMobileMenuCurrentLinkStyle)
        ctx.theme.registerStyle("public-wordmark", dev.lingvo.site.components.marketing.PublicWordmarkStyle)
        ctx.theme.registerStyle("public-wordmark-glyph", dev.lingvo.site.components.marketing.PublicWordmarkGlyphStyle)
        ctx.theme.registerStyle("public-text-link", dev.lingvo.site.components.marketing.PublicTextLinkStyle)
        ctx.theme.registerStyle("public-primary-link", dev.lingvo.site.components.marketing.PublicPrimaryLinkStyle)
        ctx.theme.registerStyle("public-secondary-link", dev.lingvo.site.components.marketing.PublicSecondaryLinkStyle)
        ctx.theme.registerStyle("public-footer", dev.lingvo.site.components.marketing.PublicFooterStyle)
        ctx.theme.registerStyle("public-footer-inner", dev.lingvo.site.components.marketing.PublicFooterInnerStyle)
        ctx.theme.registerStyle("public-footer-columns", dev.lingvo.site.components.marketing.PublicFooterColumnsStyle)
        ctx.theme.registerStyle("public-legal-link", dev.lingvo.site.components.marketing.PublicLegalLinkStyle)
        ctx.theme.registerStyle("public-footer-bottom", dev.lingvo.site.components.marketing.PublicFooterBottomStyle)
        ctx.theme.registerStyle("formats-head", dev.lingvo.site.components.marketing.FormatsHeadStyle)
        ctx.theme.registerStyle("formats-provenance", dev.lingvo.site.components.marketing.FormatsProvenanceStyle)
        ctx.theme.registerStyle("round-trip-icon", dev.lingvo.site.components.marketing.RoundTripIconStyle)
        ctx.theme.registerStyle("formats-provenance-text", dev.lingvo.site.components.marketing.FormatsProvenanceTextStyle)
        ctx.theme.registerStyle("specimen-grid", dev.lingvo.site.components.marketing.SpecimenGridStyle)
        ctx.theme.registerStyle("specimen-card", dev.lingvo.site.components.marketing.SpecimenCardStyle)
        ctx.theme.registerStyle("specimen-head", dev.lingvo.site.components.marketing.SpecimenHeadStyle)
        ctx.theme.registerStyle("specimen-name", dev.lingvo.site.components.marketing.SpecimenNameStyle)
        ctx.theme.registerStyle("specimen-path", dev.lingvo.site.components.marketing.SpecimenPathStyle)
        ctx.theme.registerStyle("specimen-code", dev.lingvo.site.components.marketing.SpecimenCodeStyle)
        ctx.theme.registerStyle("formats-rest", dev.lingvo.site.components.marketing.FormatsRestStyle)
        ctx.theme.registerStyle("formats-rest-label", dev.lingvo.site.components.marketing.FormatsRestLabelStyle)
        ctx.theme.registerStyle("formats-chip-list", dev.lingvo.site.components.marketing.FormatsChipListStyle)
        ctx.theme.registerStyle("formats-chip", dev.lingvo.site.components.marketing.FormatsChipStyle)
        ctx.theme.registerStyle("plurals-grid", dev.lingvo.site.components.marketing.PluralsGridStyle)
        ctx.theme.registerStyle("plurals-prose", dev.lingvo.site.components.marketing.PluralsProseStyle)
        ctx.theme.registerStyle("plurals-command", dev.lingvo.site.components.marketing.PluralsCommandStyle)
        ctx.theme.registerStyle("plurals-instrument", dev.lingvo.site.components.marketing.PluralsInstrumentStyle)
        ctx.theme.registerStyle("plurals-bar", dev.lingvo.site.components.marketing.PluralsBarStyle)
        ctx.theme.registerStyle("plurals-category-list", dev.lingvo.site.components.marketing.PluralsCategoryListStyle)
        ctx.theme.registerStyle("plurals-category-row", dev.lingvo.site.components.marketing.PluralsCategoryRowStyle)
        ctx.theme.registerStyle("metered-head", dev.lingvo.site.components.marketing.MeteredHeadStyle)
        ctx.theme.registerStyle("metered-head-lead", dev.lingvo.site.components.marketing.MeteredHeadLeadStyle)
        ctx.theme.registerStyle("metered-note", dev.lingvo.site.components.marketing.MeteredNoteStyle)
        ctx.theme.registerStyle("shared-assumption", dev.lingvo.site.components.marketing.SharedAssumptionStyle)
        ctx.theme.registerStyle("shared-claim", dev.lingvo.site.components.marketing.SharedClaimStyle)
        ctx.theme.registerStyle("shared-facts", dev.lingvo.site.components.marketing.SharedFactsStyle)
        ctx.theme.registerStyle("shared-fact", dev.lingvo.site.components.marketing.SharedFactStyle)
        ctx.theme.registerStyle("shared-fact-amount", dev.lingvo.site.components.marketing.SharedFactAmountStyle)
        ctx.theme.registerStyle("shared-fact-unit", dev.lingvo.site.components.marketing.SharedFactUnitStyle)
        ctx.theme.registerStyle("metered-grid", dev.lingvo.site.components.marketing.MeteredGridStyle)
        ctx.theme.registerStyle("metered-card", dev.lingvo.site.components.marketing.MeteredCardStyle)
        ctx.theme.registerStyle("metered-card-ink", dev.lingvo.site.components.marketing.MeteredCardInkStyle)
        ctx.theme.registerStyle("metered-top", dev.lingvo.site.components.marketing.MeteredTopStyle)
        ctx.theme.registerStyle("metered-tile", dev.lingvo.site.components.marketing.MeteredTileStyle)
        ctx.theme.registerStyle("metered-tile-ink", dev.lingvo.site.components.marketing.MeteredTileInkStyle)
        ctx.theme.registerStyle("metered-name", dev.lingvo.site.components.marketing.MeteredNameStyle)
        ctx.theme.registerStyle("metered-meter-group", dev.lingvo.site.components.marketing.MeteredMeterGroupStyle)
        ctx.theme.registerStyle("metered-label", dev.lingvo.site.components.marketing.MeteredLabelStyle)
        ctx.theme.registerStyle("metered-label-ink", dev.lingvo.site.components.marketing.MeteredLabelInkStyle)
        ctx.theme.registerStyle("metered-meter", dev.lingvo.site.components.marketing.MeteredMeterStyle)
        ctx.theme.registerStyle("metered-meter-ink", dev.lingvo.site.components.marketing.MeteredMeterInkStyle)
        ctx.theme.registerStyle("metered-line", dev.lingvo.site.components.marketing.MeteredLineStyle)
        ctx.theme.registerStyle("metered-line-ink", dev.lingvo.site.components.marketing.MeteredLineInkStyle)
        ctx.theme.registerStyle("metered-chart", dev.lingvo.site.components.marketing.MeteredChartStyle)
        ctx.theme.registerStyle("metered-bars", dev.lingvo.site.components.marketing.MeteredBarsStyle)
        ctx.theme.registerStyle("metered-bar", dev.lingvo.site.components.marketing.MeteredBarStyle)
        ctx.theme.registerStyle("metered-bar-billed", dev.lingvo.site.components.marketing.MeteredBarBilledStyle)
        ctx.theme.registerStyle("metered-bar-ink", dev.lingvo.site.components.marketing.MeteredBarInkStyle)
        ctx.theme.registerStyle("metered-caption", dev.lingvo.site.components.marketing.MeteredCaptionStyle)
        ctx.theme.registerStyle("metered-caption-ink", dev.lingvo.site.components.marketing.MeteredCaptionInkStyle)
        ctx.theme.registerStyle("metered-tag", dev.lingvo.site.components.marketing.MeteredTagStyle)
        ctx.theme.registerStyle("metered-tag-ink", dev.lingvo.site.components.marketing.MeteredTagInkStyle)
        ctx.theme.registerStyle("close-heading", dev.lingvo.site.components.marketing.CloseHeadingStyle)
        ctx.theme.registerStyle("close-sub", dev.lingvo.site.components.marketing.CloseSubStyle)
        ctx.theme.registerStyle("close-actions", dev.lingvo.site.components.marketing.CloseActionsStyle)
        ctx.theme.registerStyle("close-fine-print", dev.lingvo.site.components.marketing.CloseFinePrintStyle)
        ctx.theme.registerStyle("app-avatar-trigger", dev.lingvo.site.components.AppAvatarTriggerStyle)
        ctx.theme.registerStyle("section-nav", dev.lingvo.site.components.SectionNavStyle)
        ctx.theme.registerStyle("section-nav-item", dev.lingvo.site.components.SectionNavItemStyle)
        ctx.theme.registerStyle("key-pane", dev.lingvo.site.components.editor.KeyPaneStyle)
        ctx.theme.registerStyle("key-scroller", dev.lingvo.site.components.editor.KeyScrollerStyle)
        ctx.theme.registerStyle("editor-queue-essential-boundary", dev.lingvo.site.components.editor.EditorQueueEssentialBoundaryStyle)
        ctx.theme.registerStyle("editor-queue-filter-surface", dev.lingvo.site.components.editor.EditorQueueFilterSurfaceStyle)
        ctx.theme.registerStyle("editor-queue-filter-mode", dev.lingvo.site.components.editor.EditorQueueFilterModeStyle)
        ctx.theme.registerStyle("editor-queue-filter-heading", dev.lingvo.site.components.editor.EditorQueueFilterHeadingStyle)
        ctx.theme.registerStyle("editor-queue-filter-control", dev.lingvo.site.components.editor.EditorQueueFilterControlStyle)
        ctx.theme.registerStyle("compact-queue-header", dev.lingvo.site.components.editor.CompactQueueHeaderStyle)
        ctx.theme.registerStyle("compact-queue-progress", dev.lingvo.site.components.editor.CompactQueueProgressStyle)
        ctx.theme.registerStyle("compact-queue-chips", dev.lingvo.site.components.editor.CompactQueueChipsStyle)
        ctx.theme.registerStyle("key-row", dev.lingvo.site.components.editor.KeyRowStyle)
        ctx.theme.registerStyle("key-name", dev.lingvo.site.components.editor.KeyNameStyle)
        ctx.theme.registerStyle("key-target-preview", dev.lingvo.site.components.editor.KeyTargetPreviewStyle)
        ctx.theme.registerStyle("key-qa", dev.lingvo.site.components.editor.KeyQaStyle)
        ctx.theme.registerStyle("key-qa-dot", dev.lingvo.site.components.editor.KeyQaDotStyle)
        ctx.theme.registerStyle("key-source", dev.lingvo.site.components.editor.KeySourceStyle)
        ctx.theme.registerStyle("key-machine-label", dev.lingvo.site.components.editor.KeyMachineLabelStyle)
        ctx.theme.registerStyle("editor-queue-counts", dev.lingvo.site.components.editor.EditorQueueCountsStyle)
        ctx.theme.registerStyle("editor-queue-action-slot", dev.lingvo.site.components.editor.EditorQueueActionSlotStyle)
        ctx.theme.registerStyle("editor-queue-run", dev.lingvo.site.components.editor.EditorQueueRunStyle)
        ctx.theme.registerStyle("editor-bulk-confirm-body", dev.lingvo.site.components.editor.EditorBulkConfirmBodyStyle)
        ctx.theme.registerStyle("editor-bulk-preview-list", dev.lingvo.site.components.editor.EditorBulkPreviewListStyle)
        ctx.theme.registerStyle("editor-queue-filter-result", dev.lingvo.site.components.editor.EditorQueueFilterResultStyle)
        ctx.theme.registerStyle("qa-page", dev.lingvo.site.components.editor.QaPageStyle)
        ctx.theme.registerStyle("qa-filter-bar", dev.lingvo.site.components.editor.QaFilterBarStyle)
        ctx.theme.registerStyle("qa-filter-controls", dev.lingvo.site.components.editor.QaFilterControlsStyle)
        ctx.theme.registerStyle("qa-locale-select", dev.lingvo.site.components.editor.QaLocaleSelectStyle)
        ctx.theme.registerStyle("qa-summary", dev.lingvo.site.components.editor.QaSummaryStyle)
        ctx.theme.registerStyle("qa-refresh-status", dev.lingvo.site.components.editor.QaRefreshStatusStyle)
        ctx.theme.registerStyle("qa-group", dev.lingvo.site.components.editor.QaGroupStyle)
        ctx.theme.registerStyle("qa-issue-row", dev.lingvo.site.components.editor.QaIssueRowStyle)
        ctx.theme.registerStyle("qa-severity-dot", dev.lingvo.site.components.editor.QaSeverityDotStyle)
        ctx.theme.registerStyle("qa-key", dev.lingvo.site.components.editor.QaKeyStyle)
        ctx.theme.registerStyle("qa-message", dev.lingvo.site.components.editor.QaMessageStyle)
        ctx.theme.registerStyle("qa-mobile-meta", dev.lingvo.site.components.editor.QaMobileMetaStyle)
        ctx.theme.registerStyle("qa-desktop-cell", dev.lingvo.site.components.editor.QaDesktopCellStyle)
        ctx.theme.registerStyle("qa-open-label", dev.lingvo.site.components.editor.QaOpenLabelStyle)
        ctx.theme.registerStyle("qa-skeleton-row", dev.lingvo.site.components.editor.QaSkeletonRowStyle)
        ctx.theme.registerStyle("editor-utility-scrim", dev.lingvo.site.components.editor.EditorUtilityScrimStyle)
        ctx.theme.registerStyle("editor-utility-sidecar", dev.lingvo.site.components.editor.EditorUtilitySidecarStyle)
        ctx.theme.registerStyle("editor-utility-measuring", dev.lingvo.site.components.editor.EditorUtilityMeasuringStyle)
        ctx.theme.registerStyle("editor-utility-sheet", dev.lingvo.site.components.editor.EditorUtilitySheetStyle)
        ctx.theme.registerStyle("editor-utility-pane", dev.lingvo.site.components.editor.EditorUtilityPaneStyle)
        ctx.theme.registerStyle("editor-utility-header", dev.lingvo.site.components.editor.EditorUtilityHeaderStyle)
        ctx.theme.registerStyle("editor-utility-tab-list", dev.lingvo.site.components.editor.EditorUtilityTabListStyle)
        ctx.theme.registerStyle("editor-utility-tab", dev.lingvo.site.components.editor.EditorUtilityTabStyle)
        ctx.theme.registerStyle("editor-utility-tab-dot", dev.lingvo.site.components.editor.EditorUtilityTabDotStyle)
        ctx.theme.registerStyle("editor-utility-tab-panel", dev.lingvo.site.components.editor.EditorUtilityTabPanelStyle)
        ctx.theme.registerStyle("editor-utility-body", dev.lingvo.site.components.editor.EditorUtilityBodyStyle)
        ctx.theme.registerStyle("editor-utility-panel", dev.lingvo.site.components.editor.EditorUtilityPanelStyle)
        ctx.theme.registerStyle("editor-utility-empty", dev.lingvo.site.components.editor.EditorUtilityEmptyStyle)
        ctx.theme.registerStyle("editor-utility-empty-title", dev.lingvo.site.components.editor.EditorUtilityEmptyTitleStyle)
        ctx.theme.registerStyle("editor-compact-summary", dev.lingvo.site.components.editor.EditorCompactSummaryStyle)
        ctx.theme.registerStyle("editor-compact-summary-values", dev.lingvo.site.components.editor.EditorCompactSummaryValuesStyle)
        ctx.theme.registerStyle("editor-compact-summary-category", dev.lingvo.site.components.editor.EditorCompactSummaryCategoryStyle)
        ctx.theme.registerStyle("editor-utility-comment-composer", dev.lingvo.site.components.editor.EditorUtilityCommentComposerStyle)
        ctx.theme.registerStyle("editor-frame", dev.lingvo.site.components.editor.EditorFrameStyle)
        ctx.theme.registerStyle("editor-background", dev.lingvo.site.components.editor.EditorBackgroundStyle)
        ctx.theme.registerStyle("editor-workspace", dev.lingvo.site.components.editor.EditorWorkspaceStyle)
        ctx.theme.registerStyle("editor-workbench-queue", dev.lingvo.site.components.editor.EditorWorkbenchQueueStyle)
        ctx.theme.registerStyle("editor-workbench-utility", dev.lingvo.site.components.editor.EditorWorkbenchUtilityStyle)
        ctx.theme.registerStyle("editor-workbench-trio", dev.lingvo.site.components.editor.EditorWorkbenchTrioStyle)
        ctx.theme.registerStyle("editor-compact-workspace", dev.lingvo.site.components.editor.EditorCompactWorkspaceStyle)
        ctx.theme.registerStyle("editor-foundation-failure", dev.lingvo.site.components.editor.EditorFoundationFailureStyle)
        ctx.theme.registerStyle("editor-modal-scrim", dev.lingvo.site.components.editor.EditorModalScrimStyle)
        ctx.theme.registerStyle("editor-modal-surface", dev.lingvo.site.components.editor.EditorModalSurfaceStyle)
        ctx.theme.registerStyle("editor-modal-header", dev.lingvo.site.components.editor.EditorModalHeaderStyle)
        ctx.theme.registerStyle("editor-modal-body", dev.lingvo.site.components.editor.EditorModalBodyStyle)
        ctx.theme.registerStyle("editor-header", dev.lingvo.site.components.editor.EditorHeaderStyle)
        ctx.theme.registerStyle("editor-header-back-link", dev.lingvo.site.components.editor.EditorHeaderBackLinkStyle)
        ctx.theme.registerStyle("editor-header-title", dev.lingvo.site.components.editor.EditorHeaderTitleStyle)
        ctx.theme.registerStyle("editor-header-progress", dev.lingvo.site.components.editor.EditorHeaderProgressStyle)
        ctx.theme.registerStyle("editor-header-progress-bar", dev.lingvo.site.components.editor.EditorHeaderProgressBarStyle)
        ctx.theme.registerStyle("editor-pane", dev.lingvo.site.components.editor.EditorPaneStyle)
        ctx.theme.registerStyle("editor-scroll", dev.lingvo.site.components.editor.EditorScrollStyle)
        ctx.theme.registerStyle("editor-provider-settings-link", dev.lingvo.site.components.editor.EditorProviderSettingsLinkStyle)
        ctx.theme.registerStyle("editor-assist-content", dev.lingvo.site.components.editor.EditorAssistContentStyle)
        ctx.theme.registerStyle("editor-provider-controls", dev.lingvo.site.components.editor.EditorProviderControlsStyle)
        ctx.theme.registerStyle("editor-ranked-stream", dev.lingvo.site.components.editor.EditorRankedStreamStyle)
        ctx.theme.registerStyle("editor-assist-suggestion-value", dev.lingvo.site.components.editor.EditorAssistSuggestionValueStyle)
        ctx.theme.registerStyle("editor-assist-section-label", dev.lingvo.site.components.editor.EditorAssistSectionLabelStyle)
        ctx.theme.registerStyle("editor-assist-meta", dev.lingvo.site.components.editor.EditorAssistMetaStyle)
        ctx.theme.registerStyle("editor-section-heading", dev.lingvo.site.components.editor.EditorSectionHeadingStyle)
        ctx.theme.registerStyle("editor-field-section-heading", dev.lingvo.site.components.editor.EditorFieldSectionHeadingStyle)
        ctx.theme.registerStyle("editor-field-section-locale", dev.lingvo.site.components.editor.EditorFieldSectionLocaleStyle)
        ctx.theme.registerStyle("editor-target-label", dev.lingvo.site.components.editor.EditorTargetLabelStyle)
        ctx.theme.registerStyle("editor-target-error", dev.lingvo.site.components.editor.EditorTargetErrorStyle)
        ctx.theme.registerStyle("editor-qa-finding", dev.lingvo.site.components.editor.EditorQaFindingStyle)
        ctx.theme.registerStyle("editor-plural-panel", dev.lingvo.site.components.editor.EditorPluralPanelStyle)
        ctx.theme.registerStyle("editor-plural-example", dev.lingvo.site.components.editor.EditorPluralExampleStyle)
        ctx.theme.registerStyle("editor-plural-completion", dev.lingvo.site.components.editor.EditorPluralCompletionStyle)
        ctx.theme.registerStyle("editor-plural-status", dev.lingvo.site.components.editor.EditorPluralStatusStyle)
        ctx.theme.registerStyle("editor-placeholder", dev.lingvo.site.components.editor.EditorPlaceholderStyle)
        ctx.theme.registerStyle("plural-preview", dev.lingvo.site.components.editor.PluralPreviewStyle)
        ctx.theme.registerStyle("plural-source-caption", dev.lingvo.site.components.editor.PluralSourceCaptionStyle)
        ctx.theme.registerStyle("extra-plural-button", dev.lingvo.site.components.editor.ExtraPluralButtonStyle)
        ctx.theme.registerStyle("empty-editor", dev.lingvo.site.components.editor.EmptyEditorStyle)
        ctx.theme.registerStyle("editor-field-content", dev.lingvo.site.components.editor.EditorFieldContentStyle)
        ctx.theme.registerStyle("editor-identity", dev.lingvo.site.components.editor.EditorIdentityStyle)
        ctx.theme.registerStyle("editor-identity-actions", dev.lingvo.site.components.editor.EditorIdentityActionsStyle)
        ctx.theme.registerStyle("editor-identity-metadata", dev.lingvo.site.components.editor.EditorIdentityMetadataStyle)
        ctx.theme.registerStyle("editor-details-body", dev.lingvo.site.components.editor.EditorDetailsBodyStyle)
        ctx.theme.registerStyle("editor-details-field", dev.lingvo.site.components.editor.EditorDetailsFieldStyle)
        ctx.theme.registerStyle("editor-details-label", dev.lingvo.site.components.editor.EditorDetailsLabelStyle)
        ctx.theme.registerStyle("editor-details-value", dev.lingvo.site.components.editor.EditorDetailsValueStyle)
        ctx.theme.registerStyle("editor-details-tags", dev.lingvo.site.components.editor.EditorDetailsTagsStyle)
        ctx.theme.registerStyle("editor-presence", dev.lingvo.site.components.editor.EditorPresenceStyle)
        ctx.theme.registerStyle("editor-presence-count", dev.lingvo.site.components.editor.EditorPresenceCountStyle)
        ctx.theme.registerStyle("editor-eyebrow", dev.lingvo.site.components.editor.EditorEyebrowStyle)
        ctx.theme.registerStyle("editor-meta", dev.lingvo.site.components.editor.EditorMetaStyle)
        ctx.theme.registerStyle("source-surface", dev.lingvo.site.components.editor.SourceSurfaceStyle)
        ctx.theme.registerStyle("source-text", dev.lingvo.site.components.editor.SourceTextStyle)
        ctx.theme.registerStyle("editor-target-field", dev.lingvo.site.components.editor.EditorTargetFieldStyle)
        ctx.theme.registerStyle("editor-target-text-area", dev.lingvo.site.components.editor.EditorTargetTextAreaStyle)
        ctx.theme.registerStyle("editor-coarse-target", dev.lingvo.site.components.editor.EditorCoarseTargetStyle)
        ctx.theme.registerStyle("editor-field-toolbar", dev.lingvo.site.components.editor.EditorFieldToolbarStyle)
        ctx.theme.registerStyle("editor-field-toolbar-more", dev.lingvo.site.components.editor.EditorFieldToolbarMoreStyle)
        ctx.theme.registerStyle("editor-field-toolbar-popover", dev.lingvo.site.components.editor.EditorFieldToolbarPopoverStyle)
        ctx.theme.registerStyle("editor-action-bar", dev.lingvo.site.components.editor.EditorActionBarStyle)
        ctx.theme.registerStyle("editor-action-bar-row", dev.lingvo.site.components.editor.EditorActionBarRowStyle)
        ctx.theme.registerStyle("editor-save-status", dev.lingvo.site.components.editor.EditorSaveStatusStyle)
        ctx.theme.registerStyle("editor-refused-action", dev.lingvo.site.components.editor.EditorRefusedActionStyle)
        ctx.theme.registerStyle("editor-qa-blocker", dev.lingvo.site.components.editor.EditorQaBlockerStyle)
        ctx.theme.registerStyle("qa-reason", dev.lingvo.site.components.editor.QaReasonStyle)
        ctx.theme.registerStyle("editor-target-mirror", dev.lingvo.site.components.editor.EditorTargetMirrorStyle)
        ctx.theme.registerStyle("editor-target-mirror-host", dev.lingvo.site.components.editor.EditorTargetMirrorHostStyle)
        ctx.theme.registerStyle("qa-underline", dev.lingvo.site.components.editor.QaUnderlineStyle)
        ctx.theme.registerStyle("qa-underline-warning", dev.lingvo.site.components.editor.QaUnderlineWarningStyle)
        ctx.theme.registerStyle("qa-row-with-action", dev.lingvo.site.components.editor.QaRowWithActionStyle)
        ctx.theme.registerStyle("qa-group-overflow", dev.lingvo.site.components.editor.QaGroupOverflowStyle)
        ctx.theme.registerStyle("qa-group-bulk-action", dev.lingvo.site.components.editor.QaGroupBulkActionStyle)
        ctx.theme.registerStyle("pricing-intro-heading", dev.lingvo.site.pages.PricingIntroHeadingStyle)
        ctx.theme.registerStyle("plan-grid", dev.lingvo.site.pages.PlanGridStyle)
        ctx.theme.registerStyle("project-icon-upload-label", dev.lingvo.site.pages.app.projects.slug.settings.ProjectIconUploadLabelStyle)
        ctx.theme.registerStyle("project-identity-choice", dev.lingvo.site.pages.app.projects.slug.settings.ProjectIdentityChoiceStyle)
        ctx.theme.registerStyle("project-settings-surface", dev.lingvo.site.pages.app.projects.slug.settings.ProjectSettingsSurfaceStyle)
        ctx.theme.registerStyle("project-danger-action", dev.lingvo.site.pages.app.projects.slug.settings.ProjectDangerActionStyle)
        ctx.theme.registerStyle("string-permalink-header", dev.lingvo.site.pages.app.projects.slug.strings.StringPermalinkHeaderStyle)
        ctx.theme.registerStyle("design-editing-controls", dev.lingvo.site.pages.app.projects.slug.screenshots.DesignEditingControlsStyle)
        ctx.theme.registerStyle("design-narrow-notice", dev.lingvo.site.pages.app.projects.slug.screenshots.DesignNarrowNoticeStyle)
        ctx.theme.registerStyle("design-workspace-body", dev.lingvo.site.pages.app.projects.slug.screenshots.DesignWorkspaceBodyStyle)
        ctx.theme.registerStyle("shot-cell-drawer", dev.lingvo.site.pages.app.projects.slug.screenshots.ShotCellDrawerStyle)
        ctx.theme.registerStyle("shot-plan-header", dev.lingvo.site.pages.app.projects.slug.screenshots.ShotPlanHeaderStyle)
        ctx.theme.registerStyle("shot-plan-body", dev.lingvo.site.pages.app.projects.slug.screenshots.ShotPlanBodyStyle)
        ctx.theme.registerStyle("design-template-grid", dev.lingvo.site.pages.app.projects.slug.screenshots.DesignTemplateGridStyle)
        ctx.theme.registerStyle("data-file-picker-label", dev.lingvo.site.pages.app.projects.slug.DataFilePickerLabelStyle)
        ctx.theme.registerStyle("project-overview-activity-row", dev.lingvo.site.pages.app.projects.slug.ProjectOverviewActivityRowStyle)
        ctx.theme.registerStyle("summary-grid", dev.lingvo.site.pages.app.SummaryGridStyle)
        ctx.theme.registerStyle("project-grid", dev.lingvo.site.pages.app.ProjectGridStyle)
        ctx.theme.registerStyle("work-log-row-link", dev.lingvo.site.pages.app.WorkLogRowLinkStyle)
        ctx.theme.registerStyle("first-run-grid", dev.lingvo.site.pages.app.FirstRunGridStyle)
        ctx.theme.registerStyle("landing-content", dev.lingvo.site.pages.LandingContentStyle)
        ctx.theme.registerStyle("hero", dev.lingvo.site.pages.HeroStyle)
        ctx.theme.registerStyle("landing-page", dev.lingvo.site.pages.LandingPageStyle)
        ctx.theme.registerStyle("l-empty-state", dev.lingvo.site.ds.LEmptyStateStyle)
        ctx.theme.registerStyle("l-empty-state-content", dev.lingvo.site.ds.LEmptyStateContentStyle)
        ctx.theme.registerStyle("l-date-range", dev.lingvo.site.ds.LDateRangeStyle)
        ctx.theme.registerStyle("l-date-range-field", dev.lingvo.site.ds.LDateRangeFieldStyle)
        ctx.theme.registerStyle("l-date-range-input", dev.lingvo.site.ds.LDateRangeInputStyle)
        ctx.theme.registerStyle("l-date-range-value", dev.lingvo.site.ds.LDateRangeValueStyle)
        ctx.theme.registerStyle("l-date-range-arrow", dev.lingvo.site.ds.LDateRangeArrowStyle)
        ctx.theme.registerStyle("l-date-range-caption", dev.lingvo.site.ds.LDateRangeCaptionStyle)
        ctx.theme.registerStyle("l-divider", dev.lingvo.site.ds.LDividerStyle)
        ctx.theme.registerStyle("l-progress-bar", dev.lingvo.site.ds.LProgressBarStyle)
        ctx.theme.registerStyle("l-progress-cells", dev.lingvo.site.ds.LProgressCellsStyle)
        ctx.theme.registerStyle("l-progress-cell", dev.lingvo.site.ds.LProgressCellStyle)
        ctx.theme.registerStyle("l-progress-empty-cell", dev.lingvo.site.ds.LProgressEmptyCellStyle)
        ctx.theme.registerStyle("l-progress-translated-cell", dev.lingvo.site.ds.LProgressTranslatedCellStyle)
        ctx.theme.registerStyle("l-progress-approved-cell", dev.lingvo.site.ds.LProgressApprovedCellStyle)
        ctx.theme.registerStyle("l-progress-counts", dev.lingvo.site.ds.LProgressCountsStyle)
        ctx.theme.registerStyle("l-filter-bar", dev.lingvo.site.ds.LFilterBarStyle)
        ctx.theme.registerStyle("l-filter-chip-row", dev.lingvo.site.ds.LFilterChipRowStyle)
        ctx.theme.registerStyle("l-section-title-icon", dev.lingvo.site.ds.LSectionTitleIconStyle)
        ctx.theme.registerStyle("l-section-heading-icon", dev.lingvo.site.ds.LSectionHeadingIconStyle)
        ctx.theme.registerStyle("l-key-value-row", dev.lingvo.site.ds.LKeyValueRowStyle)
        ctx.theme.registerStyle("l-key-value-row-label", dev.lingvo.site.ds.LKeyValueRowLabelStyle)
        ctx.theme.registerStyle("l-key-value-row-value", dev.lingvo.site.ds.LKeyValueRowValueStyle)
        ctx.theme.registerStyle("l-key-value-row-caption", dev.lingvo.site.ds.LKeyValueRowCaptionStyle)
        ctx.theme.registerStyle("l-key-value-row-link", dev.lingvo.site.ds.LKeyValueRowLinkStyle)
        ctx.theme.registerStyle("l-stat-row-group", dev.lingvo.site.ds.LStatRowGroupStyle)
        ctx.theme.registerStyle("l-stat-row", dev.lingvo.site.ds.LStatRowStyle)
        ctx.theme.registerStyle("l-stat-row-label", dev.lingvo.site.ds.LStatRowLabelStyle)
        ctx.theme.registerStyle("l-stat-row-value", dev.lingvo.site.ds.LStatRowValueStyle)
        ctx.theme.registerStyle("l-toast", dev.lingvo.site.ds.LToastStyle)
        ctx.theme.registerStyle("toast-host", dev.lingvo.site.ds.ToastHostStyle)
        ctx.theme.registerStyle("l-toast-close", dev.lingvo.site.ds.LToastCloseStyle)
        ctx.theme.registerStyle("l-icon-badge", dev.lingvo.site.ds.LIconBadgeStyle)
        ctx.theme.registerStyle("l-avatar", dev.lingvo.site.ds.LAvatarStyle)
        ctx.theme.registerStyle("l-modal", dev.lingvo.site.ds.LModalStyle)
        ctx.theme.registerStyle("l-modal-close", dev.lingvo.site.ds.LModalCloseStyle)
        ctx.theme.registerStyle("l-copy-field", dev.lingvo.site.ds.LCopyFieldStyle)
        ctx.theme.registerStyle("l-copy-field-value", dev.lingvo.site.ds.LCopyFieldValueStyle)
        ctx.theme.registerStyle("l-copy-field-button", dev.lingvo.site.ds.LCopyFieldButtonStyle)
        ctx.theme.registerStyle("l-route-transition", dev.lingvo.site.ds.LRouteTransitionStyle)
        ctx.theme.registerStyle("l-tooltip", dev.lingvo.site.ds.LTooltipStyle)
        ctx.theme.registerStyle("l-task-progress", dev.lingvo.site.ds.LTaskProgressStyle)
        ctx.theme.registerStyle("l-task-progress-hairline", dev.lingvo.site.ds.LTaskProgressHairlineStyle)
        ctx.theme.registerStyle("l-task-progress-done-cell", dev.lingvo.site.ds.LTaskProgressDoneCellStyle)
        ctx.theme.registerStyle("l-task-progress-failed-cell", dev.lingvo.site.ds.LTaskProgressFailedCellStyle)
        ctx.theme.registerStyle("l-task-progress-detail", dev.lingvo.site.ds.LTaskProgressDetailStyle)
        ctx.theme.registerStyle("l-checkbox", dev.lingvo.site.ds.LCheckboxStyle)
        ctx.theme.registerStyle("l-checkbox-box", dev.lingvo.site.ds.LCheckboxBoxStyle)
        ctx.theme.registerStyle("l-checkbox-dash", dev.lingvo.site.ds.LCheckboxDashStyle)
        ctx.theme.registerStyle("l-switch", dev.lingvo.site.ds.LSwitchStyle)
        ctx.theme.registerStyle("l-switch-track", dev.lingvo.site.ds.LSwitchTrackStyle)
        ctx.theme.registerStyle("l-switch-thumb", dev.lingvo.site.ds.LSwitchThumbStyle)
        ctx.theme.registerStyle("l-stat-tile", dev.lingvo.site.ds.LStatTileStyle)
        ctx.theme.registerStyle("l-stat-tile-label", dev.lingvo.site.ds.LStatTileLabelStyle)
        ctx.theme.registerStyle("l-stat-tile-value", dev.lingvo.site.ds.LStatTileValueStyle)
        ctx.theme.registerStyle("l-stat-tile-delta", dev.lingvo.site.ds.LStatTileDeltaStyle)
        ctx.theme.registerStyle("l-table-container", dev.lingvo.site.ds.LTableContainerStyle)
        ctx.theme.registerStyle("l-table", dev.lingvo.site.ds.LTableStyle)
        ctx.theme.registerStyle("l-table-caption", dev.lingvo.site.ds.LTableCaptionStyle)
        ctx.theme.registerStyle("l-table-head", dev.lingvo.site.ds.LTableHeadStyle)
        ctx.theme.registerStyle("l-table-row", dev.lingvo.site.ds.LTableRowStyle)
        ctx.theme.registerStyle("l-table-header-cell", dev.lingvo.site.ds.LTableHeaderCellStyle)
        ctx.theme.registerStyle("l-table-row-header-cell", dev.lingvo.site.ds.LTableRowHeaderCellStyle)
        ctx.theme.registerStyle("l-table-cell", dev.lingvo.site.ds.LTableCellStyle)
        ctx.theme.registerStyle("l-table-selection-cell", dev.lingvo.site.ds.LTableSelectionCellStyle)
        ctx.theme.registerStyle("l-bulk-action-bar", dev.lingvo.site.ds.LBulkActionBarStyle)
        ctx.theme.registerStyle("l-bulk-action-bar-count", dev.lingvo.site.ds.LBulkActionBarCountStyle)
        ctx.theme.registerStyle("l-bulk-action-bar-note", dev.lingvo.site.ds.LBulkActionBarNoteStyle)
        ctx.theme.registerStyle("l-project-mark", dev.lingvo.site.ds.LProjectMarkStyle)
        ctx.theme.registerStyle("l-project-image", dev.lingvo.site.ds.LProjectImageStyle)
        ctx.theme.registerStyle("l-alert", dev.lingvo.site.ds.LAlertStyle)
        ctx.theme.registerStyle("l-alert-dismiss", dev.lingvo.site.ds.LAlertDismissStyle)
        ctx.theme.registerStyle("l-menu-root", dev.lingvo.site.ds.LMenuRootStyle)
        ctx.theme.registerStyle("l-menu-scrim", dev.lingvo.site.ds.LMenuScrimStyle)
        ctx.theme.registerStyle("l-menu", dev.lingvo.site.ds.LMenuStyle)
        ctx.theme.registerStyle("l-menu-item", dev.lingvo.site.ds.LMenuItemStyle)
        ctx.theme.registerStyle("l-menu-item-label", dev.lingvo.site.ds.LMenuItemLabelStyle)
        ctx.theme.registerStyle("l-menu-item-description", dev.lingvo.site.ds.LMenuItemDescriptionStyle)
        ctx.theme.registerStyle("l-menu-item-shortcut", dev.lingvo.site.ds.LMenuItemShortcutStyle)
        ctx.theme.registerStyle("l-menu-item-check", dev.lingvo.site.ds.LMenuItemCheckStyle)
        ctx.theme.registerStyle("l-menu-group-title", dev.lingvo.site.ds.LMenuGroupTitleStyle)
        ctx.theme.registerStyle("l-menu-separator", dev.lingvo.site.ds.LMenuSeparatorStyle)
        ctx.theme.registerStyle("l-breadcrumbs", dev.lingvo.site.ds.LBreadcrumbsStyle)
        ctx.theme.registerStyle("l-breadcrumbs-list", dev.lingvo.site.ds.LBreadcrumbsListStyle)
        ctx.theme.registerStyle("l-breadcrumb-item", dev.lingvo.site.ds.LBreadcrumbItemStyle)
        ctx.theme.registerStyle("l-breadcrumb-link", dev.lingvo.site.ds.LBreadcrumbLinkStyle)
        ctx.theme.registerStyle("l-breadcrumb-current", dev.lingvo.site.ds.LBreadcrumbCurrentStyle)
        ctx.theme.registerStyle("l-breadcrumb-separator", dev.lingvo.site.ds.LBreadcrumbSeparatorStyle)
        ctx.theme.registerStyle("l-card", dev.lingvo.site.ds.LCardStyle)
        ctx.theme.registerStyle("l-card-link", dev.lingvo.site.ds.LCardLinkStyle)
        ctx.theme.registerStyle("l-disclosure", dev.lingvo.site.ds.LDisclosureStyle)
        ctx.theme.registerStyle("l-disclosure-header", dev.lingvo.site.ds.LDisclosureHeaderStyle)
        ctx.theme.registerStyle("l-disclosure-caret", dev.lingvo.site.ds.LDisclosureCaretStyle)
        ctx.theme.registerStyle("l-disclosure-panel", dev.lingvo.site.ds.LDisclosurePanelStyle)
        ctx.theme.registerStyle("page-header", dev.lingvo.site.ds.PageHeaderStyle)
        ctx.theme.registerStyle("page-header-mark", dev.lingvo.site.ds.PageHeaderMarkStyle)
        ctx.theme.registerStyle("l-skeleton", dev.lingvo.site.ds.LSkeletonStyle)
        ctx.theme.registerStyle("l-spinner", dev.lingvo.site.ds.LSpinnerStyle)
        ctx.theme.registerStyle("l-select", dev.lingvo.site.ds.LSelectStyle)
        ctx.theme.registerStyle("l-select-icon", dev.lingvo.site.ds.LSelectIconStyle)
        ctx.theme.registerStyle("l-steps", dev.lingvo.site.ds.LStepsStyle)
        ctx.theme.registerStyle("l-step", dev.lingvo.site.ds.LStepStyle)
        ctx.theme.registerStyle("l-step-marker", dev.lingvo.site.ds.LStepMarkerStyle)
        ctx.theme.registerStyle("l-step-label", dev.lingvo.site.ds.LStepLabelStyle)
        ctx.theme.registerStyle("l-step-description", dev.lingvo.site.ds.LStepDescriptionStyle)
        ctx.theme.registerStyle("glyph-mosaic", dev.lingvo.site.ds.GlyphMosaicStyle)
        ctx.theme.registerStyle("glyph-mosaic-item", dev.lingvo.site.ds.GlyphMosaicItemStyle)
        ctx.theme.registerStyle("l-search-field", dev.lingvo.site.ds.LSearchFieldStyle)
        ctx.theme.registerStyle("l-search-input", dev.lingvo.site.ds.LSearchInputStyle)
        ctx.theme.registerStyle("l-tabs", dev.lingvo.site.ds.LTabsStyle)
        ctx.theme.registerStyle("l-tab-list-frame", dev.lingvo.site.ds.LTabListFrameStyle)
        ctx.theme.registerStyle("l-tab-list", dev.lingvo.site.ds.LTabListStyle)
        ctx.theme.registerStyle("l-tab", dev.lingvo.site.ds.LTabStyle)
        ctx.theme.registerStyle("l-segmented", dev.lingvo.site.ds.LSegmentedStyle)
        ctx.theme.registerStyle("l-segmented-button", dev.lingvo.site.ds.LSegmentedButtonStyle)
        ctx.theme.registerStyle("l-chip", dev.lingvo.site.ds.LChipStyle)
        ctx.theme.registerStyle("l-chip-remove", dev.lingvo.site.ds.LChipRemoveStyle)
        ctx.theme.registerStyle("l-toggle-chip", dev.lingvo.site.ds.LToggleChipStyle)
        ctx.theme.registerStyle("l-toggle-chip-count", dev.lingvo.site.ds.LToggleChipCountStyle)
        ctx.theme.registerStyle("l-field-label", dev.lingvo.site.ds.LFieldLabelStyle)
        ctx.theme.registerStyle("l-text-field-frame", dev.lingvo.site.ds.LTextFieldFrameStyle)
        ctx.theme.registerStyle("l-text-field-input", dev.lingvo.site.ds.LTextFieldInputStyle)
        ctx.theme.registerStyle("l-field-error", dev.lingvo.site.ds.LFieldErrorStyle)
        ctx.theme.registerStyle("l-text-area", dev.lingvo.site.ds.LTextAreaStyle)
        ctx.theme.registerStyle("l-chord", dev.lingvo.site.ds.LChordStyle)
        ctx.theme.registerStyle("l-conflict-card", dev.lingvo.site.ds.LConflictCardStyle)
        ctx.theme.registerStyle("l-conflict-version", dev.lingvo.site.ds.LConflictVersionStyle)
        ctx.theme.registerStyle("l-conflict-label", dev.lingvo.site.ds.LConflictLabelStyle)
        ctx.theme.registerStyle("l-button", dev.lingvo.site.ds.LButtonStyle)
        ctx.theme.registerStyle("l-button-icon", dev.lingvo.site.ds.LButtonIconStyle)
        ctx.theme.registerStyle("l-icon-button-hit-area", dev.lingvo.site.ds.LIconButtonHitAreaStyle)
        ctx.theme.registerStyle("l-code-block", dev.lingvo.site.ds.LCodeBlockStyle)
        ctx.theme.registerStyle("l-code-block-header", dev.lingvo.site.ds.LCodeBlockHeaderStyle)
        ctx.theme.registerStyle("l-code-block-pre", dev.lingvo.site.ds.LCodeBlockPreStyle)
        ctx.theme.registerStyle("l-visually-hidden", dev.lingvo.site.ds.LVisuallyHiddenStyle)
        ctx.theme.registerStyle("l-field-group", dev.lingvo.site.ds.LFieldGroupStyle)
        ctx.theme.registerStyle("l-color-field-popover", dev.lingvo.site.ds.LColorFieldPopoverStyle)
        ctx.theme.registerStyle("l-color-field-button", dev.lingvo.site.ds.LColorFieldButtonStyle)
        ctx.theme.registerStyle("l-badge", dev.lingvo.site.ds.LBadgeStyle)
        ctx.theme.registerStyle("l-badge-leading", dev.lingvo.site.ds.LBadgeLeadingStyle)
        ctx.theme.registerStyle("l-badge-dot", dev.lingvo.site.ds.LBadgeDotStyle)
        ctx.theme.registerStyle("l-pagination", dev.lingvo.site.ds.LPaginationStyle)
        ctx.theme.registerStyle("l-icon", dev.lingvo.site.ds.LIconStyle)
        ctx.theme.registerStyle("l-reveal", dev.lingvo.site.ds.LRevealStyle)
        ctx.theme.registerStyle("l-progress-ring", dev.lingvo.site.ds.LProgressRingStyle)
        ctx.theme.registerStyle("l-progress-ring-label", dev.lingvo.site.ds.LProgressRingLabelStyle)
        ctx.theme.registerStyle("l-kbd", dev.lingvo.site.ds.LKbdStyle)
        ctx.theme.registerStyle("l-split-button", dev.lingvo.site.ds.LSplitButtonStyle)
        ctx.theme.registerStyle("l-split-button-primary", dev.lingvo.site.ds.LSplitButtonPrimaryStyle)
        ctx.theme.registerStyle("l-split-button-divider", dev.lingvo.site.ds.LSplitButtonDividerStyle)
        ctx.theme.registerStyle("l-split-button-trigger", dev.lingvo.site.ds.LSplitButtonTriggerStyle)
        ctx.theme.registerStyle("l-split-button-menu", dev.lingvo.site.ds.LSplitButtonMenuStyle)
        ctx.theme.registerKeyframes("billed-row-enter", dev.lingvo.site.components.marketing.BilledRowEnter)
        ctx.theme.registerKeyframes("wall-settle", dev.lingvo.site.components.marketing.WallSettle)
        ctx.theme.registerKeyframes("l-route-enter", dev.lingvo.site.ds.LRouteEnter)
        ctx.theme.registerKeyframes("l-skeleton-shimmer", dev.lingvo.site.ds.LSkeletonShimmer)
        ctx.theme.registerKeyframes("l-spinner-rotation", dev.lingvo.site.ds.LSpinnerRotation)
        ctx.theme.registerKeyframes("glyph-mosaic-settle", dev.lingvo.site.ds.GlyphMosaicSettle)
        ctx.theme.registerKeyframes("l-reveal-up", dev.lingvo.site.ds.LRevealUp)
        ctx.theme.registerKeyframes("l-reveal-left", dev.lingvo.site.ds.LRevealLeft)
        ctx.theme.registerKeyframes("l-reveal-settle", dev.lingvo.site.ds.LRevealSettle)
        dev.lingvo.site.ds.initLingvoTheme(ctx)
        dev.lingvo.site.i18n.initI18n(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.lingvo.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
